import styled from 'styled-components';
import { Typography } from '../../../global/theme';

const FormButton = styled.div`
  display: flex;
  gap: var(--space-12);
  align-items: flex-end;
  justify-content: flex-end;
  padding: var(--space-0) var(--space-16) var(--space-16) var(--space-16);
`;

const ModalBlock = styled.form`
  display: flex;
  flex-direction: column;
`;

const Formation = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  padding: var(--space-16) var(--space-16) var(--space-24);
`;

const Label = styled.label`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  span {
    color: var(--accent-error);
  }
`;

export { FormButton, Formation, ModalBlock, Label };
